/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const getCustomerEC2Policy = `query getCustomerEC2Policy($customer_id: String!) {
  customerEC2Policy(customer_id: $customer_id)
}
`;
